import React, { Component } from "react";
import Image from "../../src/Components/Image";

export class BotAvatar extends Component {
  render() {
    const { isLast } = this.props;

    return (
      <>
        {isLast ? (
          <Image
            src="../images/pages/landing/daka.png"
            style={{
              width: 30,
              height: 30,
              marginRight: 8,
              borderRadius: 13
            }}
          />
        ) : (
          <div style={{ width: 30, height: 30, marginRight: 8 }} />
        )}
      </>
    );
  }
}

export default BotAvatar;
